import { AVATAR_GROUP } from "./constants.js";
const es = {
    [AVATAR_GROUP]: {
        MEMBERS: 'Miembros'
    }
};
export { es };
